/*!

=========================================================
* Black Dashboard React v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, {useState, useEffect} from "react";
import { connect } from "react-redux";
import {useHistory} from "react-router-dom"

// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Button,
  Table,
  Row,
  Col,
} from "reactstrap";
import withReactContent from "sweetalert2-react-content";
import api from "../../utils/axiosApi";
import { option, Toast } from "../../utils/sweetalert";

function Tables() {
    const history = useHistory()
    const handleEdit = (a) => {
        
        history.push({
          pathname: `/admin/edit-profile/${a._id}`,
          state: {
            name: a.name,
            email: a.email
          }
        })
    }
    const [admins, setAdmins] = useState([])
    useEffect(() => {
      const requestAdmins = async () => {
          try {
            const resp = await api.get('/user/getusers')
            setAdmins(resp.data.data)
          } catch (error) {
            //console.log(error)
          } 
      }
      requestAdmins()
      return 
    }, [])
    const handleDelete = async (e ) => {
      const MySwal = withReactContent(option)
      const resp = await MySwal.fire({
      title: <p style={{fontSize: '22px', zIndex: 30000}}>Ingrese el password del usuario a eliminar</p>,
      html: `<input type="password" id="passwordDel" class="swal2-input fs-2rem" placeholder="Desea eliminarlo">
      `,
      confirmButtonText: 'Eliminar',
      focusConfirm: false,
      preConfirm: () => {
        const password = MySwal.getPopup().querySelector('#passwordDel').value
        if (!password) {
          MySwal.showValidationMessage(`Por favor, ingrese el password`)
        }
        return { password: password}
      }
    })
    if (resp) {
      try {
        const respbd = await api.post(`/user/deleteUser/${e._id}`, {
          password: resp.value.password
        })
        if(!respbd.data.error) {
          const adminscopy = [...admins]
          const ideliminar = adminscopy.findIndex((element) => {
            return element._id === e._id
          })
          adminscopy.splice(ideliminar, 1)
          setAdmins(adminscopy)
          const MySwal = withReactContent(Toast)
            await MySwal.fire({
                title: <p style={{fontSize: '15px'}}>Admin eliminado Exitosamente</p>,
                icon: 'success',
            })
        } else {
          const MySwal = withReactContent(Toast)
            await MySwal.fire({
                title: <p style={{fontSize: '15px'}}>Password invalida</p>,
                icon: 'error',
            })
        }
      } catch (error) {
        const MySwal = withReactContent(Toast)
            await MySwal.fire({
                title: <p style={{fontSize: '15px'}}>Parece que hubo un error...</p>,
                icon: 'error',
            })
        //console.log(error)
      }
    }
    }
  return (
    <>
      <div className="content">
        <Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <CardTitle tag="h4">Administradores</CardTitle>
              </CardHeader>
              <CardBody>
                <Table className="tablesorter" responsive>
                  <thead className="text-primary">
                    <tr>
                      <th>Nombre</th>
                      <th>correo</th>
                      <th>Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                  {admins.map((a,index) => (
                    <tr key={`admin-${index}`}>
                      <td>{a.name}</td>
                      <td>{a.email}</td>
                      <td>
                      <Row>
                        <Col md='6'>
                            <Button onClick={() => {handleEdit(a)}} size='sm' type='button' color='info'> Editar</Button>
                        </Col>
                        <Col md='6'>
                            <Button onClick={() => {handleDelete(a)}}  size='sm' type='button' color='danger'> Eliminar</Button>
                        </Col>
                      </Row>
                      </td>
                    </tr>
                  ))}
                    {(admins.length === 0) ?
                      (<tr>
                      <td>cargando</td>
                      <td></td>
                      <td>
                      </td>
                    </tr>) : <></>
                    }
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
          
        </Row>
      </div>
    </>
  );
}

const mapStateToProps = state => {
  return ({
})}
const mapDispatchToProps = dispatch => (
  {
  })


export default connect(mapStateToProps,mapDispatchToProps)(Tables);
